type EnvironmentSpecificConfig = {
  API_URL: string;
};

const dev: EnvironmentSpecificConfig = {
  API_URL: 'http://localhost:8088/dev',
};
const test: EnvironmentSpecificConfig = {
  API_URL: 'https://c3fpxmuyoh-vpce-05230a3b44834b6c7.execute-api.eu-central-1.amazonaws.com/test',
};

const prod: EnvironmentSpecificConfig = {
  API_URL: 'https://k2tkczr5c3-vpce-029a257f23c61e79f.execute-api.eu-central-1.amazonaws.com/prod',
};

const env = process.env.REACT_APP_STAGE || 'dev';

const config = env === 'test' ? test : env === 'prod' ? prod : dev;

const mergedConfig = {
  ...config,
  STANDALONE: env === 'dev',
};

export const MICROFRONTEND_ID = 'lehrgangsbuchungen';

export default mergedConfig;
